import FeatureButton from '@medflex/components/stories/FeatureButton';
import Modal from '@medflex/components/stories/Modal';
import { IconUser, IconUserGroup } from '@medflex/components/stories/Icons';
import InfoBanner, { KINDS as INFO_BANNER_KINDS } from '@medflex/components/stories/InfoBanner';
import Button from '@medflex/components/stories/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge, { KINDS } from '@medflex/components/stories/Badge';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import useFeatures from '../hooks/useFeatures';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';

const PhysicianScheduleCallSwitchModule = () => {
  const { close, open } = useModal();
  const [meetings, groupMeetings] = useFeatures([
    FEATURE_KEYS.SESSION_MEETING,
    FEATURE_KEYS.SESSION_MEETING_GROUP,
  ]);
  const { t } = useTranslation(['physician', 'global']);

  return (
    <Modal
      showCloseButton
      onClickCloseButton={() => close({ modal: 'videoauswahl' })}
      title={t('PhysicianScheduleCallSwitchModule.title')}
    >
      <div data-component="PhysicianScheduleCallSwitchModule" className="flex flex-col">
        {meetings && meetings.limit && (
          <InfoBanner kind={INFO_BANNER_KINDS.SIGNAL} className="mb-8 w-full p-5">
            {meetings.active ? (
              <>
                {t('infoBanner.active', {
                  allowHtml: true,
                  count: meetings.limit - meetings.count,
                  ns: 'global',
                })}
                <Button
                  kind="link"
                  onClick={() => open({ modal: MODALS.featureUpgradeSessionMeetingGroup })}
                >
                  {t('infoBanner.upgrade', { ns: 'global' })}
                </Button>
              </>
            ) : (
              <>
                {t('infoBanner.used_up', { allowHtml: true, ns: 'global' })}
                <Button
                  kind="link"
                  onClick={() => open({ modal: MODALS.featureUpgradeSessionMeetingGroup })}
                >
                  {t('infoBanner.upgrade', { ns: 'global' })}
                </Button>
              </>
            )}
          </InfoBanner>
        )}
        <FeatureButton
          onClick={() =>
            meetings.active
              ? open({
                  modal: MODALS.sessionsCreate,
                  mode: 'single',
                })
              : open({ modal: MODALS.featureUpgradeSessionMeeting })
          }
          icon={<IconUser size="8" />}
          title={t('PhysicianScheduleCallSwitchModule.single.title')}
          subtitle={t('PhysicianScheduleCallSwitchModule.single.text')}
          className="mb-6"
          badge={
            meetings &&
            !meetings.active && (
              <Badge kind={KINDS.SIGNAL}>{t('PhysicianScheduleCallSwitchModule.upgrade')}</Badge>
            )
          }
        />
        <FeatureButton
          onClick={() =>
            groupMeetings.active
              ? open({ modal: MODALS.sessionsCreate, mode: 'group' })
              : open({ modal: MODALS.featureUpgradeSessionMeetingGroup })
          }
          icon={<IconUserGroup size="8" />}
          title={t('PhysicianScheduleCallSwitchModule.group.title')}
          subtitle={t('PhysicianScheduleCallSwitchModule.group.text')}
          badge={
            groupMeetings &&
            !groupMeetings.active && (
              <Badge kind={KINDS.SIGNAL}>{t('PhysicianScheduleCallSwitchModule.upgrade')}</Badge>
            )
          }
        />
      </div>
    </Modal>
  );
};

export default PhysicianScheduleCallSwitchModule;
